export default __webpack_public_path__ + "static/media/location_preview_art_museum.214e9c00.svg";